import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class GlobalProgressBarService {
  private _isLoading = signal(false);

  public readonly isLoading = this._isLoading.asReadonly();

  private _requestsCount = 0;
  private _debounceTimer: ReturnType<typeof setTimeout> | null = null;

  public show() {
    this._requestsCount++;

    if (this._debounceTimer) {
      clearTimeout(this._debounceTimer);
      this._debounceTimer = null;
    }

    this._isLoading.set(true);
  }

  public hide() {
    if (this._requestsCount > 0) {
      this._requestsCount--;
    }

    if (this._requestsCount === 0) {
      this._debounceTimer = setTimeout(() => {
        if (this._requestsCount === 0) {
          this._isLoading.set(false);
        }
        this._debounceTimer = null;
      }, 200);
    }
  }
}
